// import Layout from '@/layout'

const forceTelRouter = {
  path: '',
  component: () => import('@/views/forceTel/index'),
  redirect: 'forceTel',
  name: '绑定手机号',
  meta: {
    title: '绑定手机号',
    icon: 'el-icon-s-home'
  },
  children: [
    {
      path: 'forceTel',
      name: '绑定手机号',
      meta: {
        title: '绑定手机号'
      },
      component: () => import('@/views/forceTel/index')
    }
  ]
}

export default forceTelRouter
